import { render } from "./ImportValuePlayerIcon.vue?vue&type=template&id=000d54a0"
import script from "./ImportValuePlayerIcon.vue?vue&type=script&lang=js"
export * from "./ImportValuePlayerIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__